import { Login as LoginComponent } from '../components/Login/index.tsx';

export function Login() {
  return (
    <div>
      <LoginComponent />
    </div>
  );
}
